import { Either, Left, Right } from 'fp-ts/lib/Either'
import superagent from 'superagent'

import { log } from '@/log'
import GameCampaignContents from '@/models/game/game-campaign-contents'
import AppId from '@/util/appid'
import { ApiClient } from './client'
import { ApiService } from './service'

const namespace: string = 'campaign'

export default class CampaignService extends ApiService {

  async listNovelty(): Promise<Either<Error, superagent.Response>> {
    try {
      const brand = AppId.getBrandNameByAppId(this.appId)
      const response = await ApiClient.get(`/api/${brand}/cart/novelties`)

      log.debug({ service: `${namespace}/list`, response })

      return new Right(response)
    } catch (error) {
      log.error({ service: `${namespace}/list`, error })

      return new Left(error)
    }
  }

  async post(campaignId: string, brandEnglishName?: string): Promise<Either<Error, GameCampaignContents>> {

    const endpoint = this.makeEndpoint(brandEnglishName)

    try {
      const response = await ApiClient
        .post(endpoint)
        .send({
          id: campaignId,
        })

      log.debug({ service: `${namespace}/post`, response })

      return new Right(new GameCampaignContents(response.body.data.game_contents))
    } catch (error) {
      log.error({ service: `${namespace}/post`, error })

      return new Left(error)
    }
  }

  private makeEndpoint(brandEnglishName?: string): string {

    if (brandEnglishName && brandEnglishName.length > 0) {

      return `/api/${brandEnglishName}/campaign`
    }

    return '/api/campaign'
  }
}
